import isEqual from 'lodash/isEqual';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

// This hook is a modified useState that makes sure to update the state whenever `value` changes
// Similar to a controlled component.
export function useControlledState<T>(
  value: T
): [T, Dispatch<SetStateAction<T>>, Dispatch<SetStateAction<boolean>>] {
  const [state, setState] = useState<T>(value);
  const [disabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (!isEqual(state, value) && !disabled) {
      setState(value);
    }
  }, [value, disabled]);

  return [state, setState, setDisabled];
}
